<template>
    <div id="whatsapp-business-channels">
        <AppBreadCrumb :paths="[{ title: $t('whatsapp_business_api.title') }]" :select="true"></AppBreadCrumb>
        <div style="background-color: #ffffff" class="d-flex right-page">
            <div class="ml-3 mt-3" style="flex: 0 0 100%">
                <div class="big-title">{{ $t("whatsapp_business_api.title") }}</div>
                <div class="channels">
                    <div
                        class="story channel-add"
                        @click="$feature.beforeCreateIntegrationChannel(createNewChannel, 'whatsapp-business-api')"
                    >
                        <a-icon type="plus-circle" theme="filled" style="font-size: 30px" />
                        <span class="text-large font-weight-bolder mt-2" style="font-size: 20px; letter-spacing: 2px">
                            {{ $t("whatsappChannel.addChannel") }}
                        </span>
                    </div>
                    <div
                        class="channel-item"
                        :class="{ disabled: !isChannelAccessible(channel) }"
                        v-for="(channel, index) in channels"
                        @click="() => isChannelAccessible(channel) && editChannel(channel)"
                        :key="index"
                    >
                        <div class="icon-container">
                            <WhatsappBusinessIcon />
                        </div>
                        <div class="name-container">
                            <span class="name">{{ channel.name.toUpperCase() }}</span>
                            <span class="phone"> ({{ channel.forward.mode }}) </span>
                        </div>

                        <div class="options">
                            <a-dropdown :trigger="['click']" placement="bottomRight">
                                <div class="icon-container ant-dropdown-link" @click="(e) => e.stopPropagation()">
                                    <span class="material-icons">more_horiz</span>
                                </div>
                                <template #overlay>
                                    <a-menu>
                                        <a-menu-item>
                                            <div
                                                class="icon-container"
                                                @click="$router.push(`/integrations/waba/${channel._id}/detail`)"
                                            >
                                                <md-icon style="margin-right: 10px">edit</md-icon>
                                                <span>{{ $t("message.edit") }}</span>
                                            </div>
                                        </a-menu-item>
                                        <a-menu-item>
                                            <div class="icon-container" @click="deleteWpBusiness(channel._id)">
                                                <md-icon style="margin-right: 10px">delete</md-icon>
                                                <span>{{ $t("chatbotv2.delete") }}</span>
                                            </div>
                                        </a-menu-item>
                                    </a-menu>
                                </template>
                            </a-dropdown>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <a-modal
            :visible="createChannelModalVisible"
            title="Yeni WhatsApp Business API Kanalı"
            @cancel="createChannelModalVisible = false"
            :maskClosable="false"
        >
            <template slot="footer">
                <a-button key="back" @click="createChannelModalVisible = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="primary" @click="confirmCreateChannel" :loading="loading">
                    {{ $t("message.create") }}
                </a-button>
            </template>
            <div class="input-wrapper">
                <label>{{ $t("whatsapp_business_api.channelName") }}</label>
                <a-input v-model="newChannelName" :placeholder="$t('whatsapp_business_api.channelName')" />
            </div>
        </a-modal>

        <a-modal
            :visible="deleteModal"
            icon="exclamation-circle"
            :title="$t('whatsappChannel.whatsappChannel')"
            @cancel="deleteModal = false"
        >
            <p>{{ $t("whatsappChannel.deleteWhatsappChannelDescription") }}</p>
            <template #footer>
                <a-button key="back" @click="deleteModal = false">
                    {{ $t("chatbotv2.dismiss") }}
                </a-button>
                <a-button key="submit" type="danger" @click="deleteWhatsappChannel">
                    {{ $t("chatbotv2.delete") }}
                </a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import InstagramIcon from "../Chatbot/pages/integrations/svg/InstagramIcon.vue";
import WebhookIcon from "../Chatbot/pages/integrations/svg/WebhookIcon.vue";
import SkypeIcon from "../Chatbot/pages/integrations/svg/SkypeIcon.vue";
import FacebookIcon from "../Chatbot/pages/integrations/svg/FacebookIcon.vue";
import ShopifyIcon from "../../../components/fast-initialize/svg/ShopifyIcon.vue";
import SlackIcon from "../Chatbot/pages/integrations/svg/SlackIcon.vue";
import TwitterIcon from "../Chatbot/pages/integrations/svg/TwitterIcon.vue";
import SupsisIcon from "../Chatbot/pages/integrations/svg/SupsisIcon.vue";
import TelegramIcon from "../Chatbot/pages/integrations/svg/TelegramIcon.vue";
import WhatsappIcon from "../Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Modal2 from "../../../components/common/Modal2.vue";
import WhatsappBusinessIcon from "../Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import AppBreadCrumb from "../../../components/common/AppBreadCrumb.vue";
import { createChannel } from "../../../api/channel";
import _ from "lodash";

export default {
    name: "WABAChannels",
    components: {
        WhatsappIcon,
        TelegramIcon,
        SupsisIcon,
        TwitterIcon,
        SlackIcon,
        ShopifyIcon,
        FacebookIcon,
        SkypeIcon,
        WebhookIcon,
        InstagramIcon,
        Modal2,
        WhatsappBusinessIcon,
        AppBreadCrumb,
    },
    data() {
        return {
            deleteModal: false,
            deleteChannelId: null,
            createChannelModalVisible: false,
            newChannelName: "",
            loading: false,
        };
    },
    computed: {
        ...mapState({
            channels: (state) => state.channel.channels.filter((x) => x.type === "whatsapp-business-api-supsis"),
            isAdmin: (state) => state.auth.adminUser !== null,
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        ...mapActions({
            listChannels: "channel/listChannels",
            listStories: "CB/listStories",
            deleteChannel: "channel/deleteChannel",
        }),
        ...mapGetters({
            isChannelVisibleForMe: "channel/isChannelVisibleForMe",
        }),
        createNewChannel() {
            this.createChannelModalVisible = true;
            this.newChannelName = "";
        },
        confirmCreateChannel() {
            if (!this.newChannelName.trim()) {
                this.$message.error("Kanal adı boş olamaz");
                return;
            }

            this.loading = true;
            createChannel(
                "whatsapp-business-api-supsis",
                this.newChannelName,
                {}, // payload boş olacak
                { users: [], departments: [] }, // visibility
                { mode: "live", story: null }, // forward
                {} // commentForward
            )
                .then((response) => {
                    this.loading = false;
                    this.createChannelModalVisible = false;
                    this.listChannels();

                    // Detay sayfasına yönlendir
                    const channelId = response.data._id;
                    this.$router.push(`/integrations/waba/${channelId}/detail`);
                })
                .catch((error) => {
                    this.loading = false;
                    this.$message.error("Kanal oluşturulurken bir hata oluştu: " + (error.message || error));
                });
        },
        deleteWpBusiness(id) {
            this.deleteModal = true;
            this.deleteChannelId = id;
        },
        editChannel(channel) {
            this.$router.push(`/integrations/waba/${channel._id}/detail`);
        },
        deleteWhatsappChannel() {
            this.deleteModal = false;
            this.deleteChannel(this.deleteChannelId);
        },
        isChannelAccessible(channel) {
            return (
                this.isAdmin ||
                _.get(this.user, "isOwner", false) ||
                _.get(this.user, "role.isRoot", false) ||
                this.isChannelVisibleForMe(channel)
            );
        },
    },
    mounted() {
        this.listChannels();
        this.listStories();
    },
};
</script>

<style lang="scss" scoped>
#whatsapp-business-channels {
    width: 100%;
    min-height: calc(100vh - 50px);
    background: var(--color-bg-default);

    .channel-item.disabled {
        opacity: 0.5;
        pointer-events: none;
    }

    .big-title {
        font-weight: bold;
        font-size: 1.5rem;
        margin: 1rem 0;
    }

    .channels {
        display: flex;
        align-items: flex-start;
        padding-bottom: 1rem;
        flex-wrap: wrap;
        gap: 1rem;

        .story {
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            margin-top: 10px;

            &:hover {
                border: 1px solid #06a9f3;
            }

            .title {
                margin: 1rem 0;
                font-weight: bold;
            }

            .chatbot-btn {
                border: none;
                background: #fff;
                border-radius: 4px;
                padding: 4px 8px;
                margin: 0;
                min-height: 34px;
                min-width: 34px;
                color: #000;
                display: flex;
                align-items: center;
                box-shadow: none !important;
                text-shadow: none !important;

                span {
                    text-align: left;
                }
            }
        }

        .channel-item {
            position: relative;
            background: #fff;
            border: 1px solid #a4a4a4;
            border-radius: 4px;
            padding: 1rem;
            cursor: pointer;
            transition: all 0.3s ease-in-out;
            width: 280px;
            height: 260px;
            min-width: 250px;
            max-width: 250px;
            text-align: center;
            transition: 500ms;
            margin-top: 10px;

            .web-hook-title {
                word-break: break-all;
            }

            &:hover {
                border: 1px solid #06a9f3;

                span {
                    color: #06a9f3;
                }

                transform: translateY(-10px);
                box-shadow: -4px 22px 11px -5px rgba(0, 0, 0, 0.1);

                .options {
                    .icon-container {
                        i {
                            transform: rotate(360deg);
                            color: #06a9f3;
                        }
                    }
                }
            }

            .icon-container {
                width: 70px;
                height: 70px;
                display: flex;
                margin: 0 auto;
                align-items: center;
                justify-content: center;
                border-radius: 6px;
                margin-top: 69px;
                overflow: hidden;
                position: relative;
                background: #58ca64;
                padding: 10px;
            }

            .name-container {
                display: flex;
                flex-direction: column;
                gap: 5px;
                font-size: 20px;
                font-weight: bold;
                margin-top: 10px !important;

                .phone {
                    font-size: 14px;
                    font-weight: normal;
                    color: #a4a4a4;
                }
            }

            span {
                margin: 1rem 0;
                margin-top: 10px !important;
                font-weight: bold;
                display: block;
                font-size: 20px;
                transition: 10ms;
            }

            .options {
                position: absolute;
                top: 5px;
                right: 5px;

                .icon-container {
                    background-color: transparent;
                    width: 25px;
                    height: 35px;
                    margin: 0;
                    padding: 0;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    padding: 3px;

                    i {
                        width: 100%;
                        height: 100%;
                        transition: 1s;
                    }
                }
            }
        }

        .channel-add {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #006cff;
            border-color: #006cff;
            color: #fff;

            i {
                margin: 0;
            }
        }
    }

    .input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 5px;
        margin-bottom: 15px;
    }
}
</style>
